import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { SERVER_IP } from "@/lib/api";
import { sfx } from "@/lib/sounds";

export default function IPPill({ large = false, testId = "hero-copy-ip" }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(SERVER_IP);
      setCopied(true);
      sfx.copy();
      toast.success("Server IP copied!", { description: SERVER_IP });
      setTimeout(() => setCopied(false), 1800);
    } catch {
      sfx.error();
      toast.error("Copy failed");
    }
  };

  return (
    <button
      onClick={copy}
      data-testid={testId}
      className={`inline-flex items-center gap-3 rounded-full glass hover:border-[#FFBF00]/60 group ${
        large ? "px-6 py-4" : "px-4 py-2"
      }`}
    >
      <span className="w-2.5 h-2.5 rounded-full bg-green-500 pulse-dot" />
      <span className={`font-mono ${large ? "text-lg sm:text-xl" : "text-sm"} text-[#FFBF00]`}>{SERVER_IP}</span>
      {copied ? <Check size={large ? 20 : 16} className="text-[#FFBF00]" /> : <Copy size={large ? 20 : 16} className="text-white/70 group-hover:text-[#FFBF00]" />}
    </button>
  );
}
